var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ribbon"},[_c('span',{class:['font-weight-bold','text-capitalize', _vm.status_hacienda]},[_vm._v("\n    "+_vm._s(_vm.status_hacienda)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }